import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, FontWeights, minWidth, Text, TextElements } from '@calm-web/design-system';

import LimitedTimeCalloutRaw from '@/components/PreSignupFlow/Components/LimitedTimeCallout';

export const HeroSection = styled.section`
	background: ${palette('gradientCalmBrand')};
	padding: 40px 14px;
	position: relative;
	${minWidth('tablet')} {
		padding: 75px;
		background:
			url('/_n/images/discount-landing/discount-app-icons.webp') bottom right / 40%,
			${palette('gradientCalmBrand')};
		background-position: right bottom;
		background-repeat: no-repeat;
	}
	${minWidth('desktop')} {
		background-size: contain;
		background-position: right center;
	}
`;

export const Title = styled(Text).attrs({
	color: 'white',
	el: TextElements.H1,
	size: FontSizes['2xl'],
})`
	${minWidth('tablet')} {
		${fontSize(FontSizes['4xl'])}
	}
`;
export const Detail = styled(Text).attrs({
	color: 'white',
	el: TextElements.P,
	weight: FontWeights.Light,
})`
	padding-bottom: 20px;
	max-width: 600px;
`;

export const GridWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	text-align: center;
	max-width: 1168px;
	margin: auto;

	${minWidth('tablet')} {
		text-align: start;
	}
`;

export const LimitedTimeCallout = styled(LimitedTimeCalloutRaw)`
	margin: 0;
`;
